'use client';

import { Grid2, Stack, Typography } from '@mui/material';

export const PricingSection = () => {
  const pricingFeatures = [
    'No onboarding fees',
    'No hidden markups',
    'No termination penalties',
    'Clear monthly costs',
  ];

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '80px' }}
      paddingY={{ xs: '32px', sm: '80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}
      sx={{
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}>
      <Stack gap={{ xs: 3, sm: 5 }} width={'min(1280px, 100%)'} zIndex={2}>
        {/* Title */}
        <Stack alignItems={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            fontSize={{ xs: '20px', sm: '36px' }}
            lineHeight={{ xs: '24px', sm: '48px' }}
            textAlign={'center'}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            SIMPLE, PREDICTABLE PRICING
          </Typography>
        </Stack>

        {/* Features */}
        <Stack alignItems={'center'}>
          {' '}
          <Grid2 container spacing={{ xs: 2, sm: 2 }} width={'min(800px, 100%)'} justifyContent={'center'}>
            {pricingFeatures.map((feature, index) => (
              <Grid2 size={{ xs: 12, sm: 6 }} key={index}>
                <Stack direction={'row'} alignItems={'center'} gap={3}>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <mask id='path-1-inside-1_1785_4708' fill='white'>
                      <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' />
                    </mask>
                    <path
                      d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'
                      fill='#0ACBE6'
                      fillOpacity='0.2'
                    />
                    <path
                      d='M12 24V23C5.92487 23 1 18.0751 1 12H0H-1C-1 19.1797 4.8203 25 12 25V24ZM24 12H23C23 18.0751 18.0751 23 12 23V24V25C19.1797 25 25 19.1797 25 12H24ZM12 0V1C18.0751 1 23 5.92487 23 12H24H25C25 4.8203 19.1797 -1 12 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z'
                      fill='#0ACBE6'
                      fillOpacity='0.5'
                      mask='url(#path-1-inside-1_1785_4708)'
                    />
                    <path
                      d='M17.3337 8L10.0003 15.3333L6.66699 12'
                      stroke='#0ACBE6'
                      strokeWidth='1.33333'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>

                  <Typography fontSize={{ xs: '14px', sm: '18px' }} variant={'bodyLarge'} color={'#FFFFFF'}>
                    {feature}
                  </Typography>
                </Stack>
              </Grid2>
            ))}
          </Grid2>
        </Stack>

        {/* Pricing Cards */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          gap={{ xs: 2, sm: 3 }}
          width={'100%'}
          justifyContent={'center'}
          paddingX={{ xs: 0, sm: '120px' }}>
          {/* Price Card */}
          <Stack
            alignItems={'center'}
            gap={3}
            padding={{ xs: '16px', sm: '32px' }}
            sx={{
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '4px',
              flex: 1,
            }}>
            <Typography
              fontSize={{ xs: '14px', sm: '18px' }}
              variant={'bodyLarge'}
              color={'#FFFFFF'}
              textAlign={'center'}>
              As low as
            </Typography>
            <Stack alignItems={'center'} gap={1}>
              <Stack direction={'row'} alignItems={'baseline'} gap={0.5} flexWrap={'wrap'}>
                <Typography
                  fontSize={{ xs: '24px', sm: '36px' }}
                  lineHeight={{ xs: '33px', sm: '48px' }}
                  fontWeight={700}
                  color={'#FFFFFF'}>
                  $199
                </Typography>
                <Typography fontSize={{ xs: '12px', sm: '16px' }} variant={'bodyMedium'} color={'#9E9E9E'}>
                  /month
                </Typography>
              </Stack>
              <Typography
                fontSize={{ xs: '14px', sm: '18px' }}
                variant={'bodyLarge'}
                color={'#FFFFFF'}
                textAlign={'center'}>
                Per employee
              </Typography>
            </Stack>
          </Stack>

          {/* Visas Card */}
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            gap={2}
            padding={{ xs: '16px', sm: '32px' }}
            sx={{
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '4px',
              flex: 1,
            }}>
            <Typography
              fontSize={{ xs: '20px', sm: '28px' }}
              lineHeight={{ xs: '28px', sm: '40px' }}
              fontWeight={700}
              color={'#FFFFFF'}
              textAlign={'center'}>
              Visas & Work permits
            </Typography>
            <Typography
              fontSize={{ xs: '14px', sm: '18px' }}
              variant={'bodyLarge'}
              color={'#FFFFFF'}
              textAlign={'center'}>
              Subject to local government
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
